import { useCallback, useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
import { SupportedLocale } from '@/_shared/types/languages';
import { putSetLanguageCall } from '@/core/state/api';
import { useLogin } from '@/login/state';
import configureI18n from '../../configuration/i18n';

export const useLanguageSelector = () => {
  const { store } = useContext(ReactReduxContext);
  const { isUserLogged } = useLogin();
  const { execute: executePutSetLanguage } = putSetLanguageCall.hook();
  const changeLanguage = useCallback(
    (lang: SupportedLocale['value'], langCode: SupportedLocale['langCode']) => {
      configureI18n(store, lang, langCode);
      if (isUserLogged) {
        executePutSetLanguage({ language: lang });
      }
    },
    [store, isUserLogged, executePutSetLanguage],
  );

  return {
    changeLanguage,
  };
};
